import React from 'react'
import ProductListTable from './Components/ProductTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const ProductList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Product List</HeadingOne>
          <AddItemBtn url="add-items-list" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <ProductListTable />
      </div>
    </PageBody>
  );
};

export default ProductList;
